import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FeesEstimationAdminService } from '../../shared/services/fees-estimation-admin.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FeesEstimationAdminDto } from '../../shared/models/fees-estimation-admin.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { MeasurmentOfficerDecision, Languages, FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { FeesEstimationService } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation.service';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';

@Component({
  selector: 'app-measurement-officer-fees',
  templateUrl: './measurement-officer-fees.component.html',
  styleUrls: ['./measurement-officer-fees.component.css']
})
export class MeasurementOfficerFeesComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  public measurementOfficerForm: FormGroup;
  user: User = new User();
  showRequest = false;
  MeasurmentOffcierObject: FeesEstimationAdminDto = new FeesEstimationAdminDto();
  baseRequestDTO: BaseRequest //= new BaseRequest();
  displayedLang: string;
  decision = MeasurmentOfficerDecision;
  decisionKeys = Object.keys(this.decision);
  requestStatus: number;
  agentId: string;
  //public formMode: FormMode.Readonly;
  feesEstimationObj: FeesEstimate = new FeesEstimate();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @Input() public isShow: boolean = true;

  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private feesSrv: FeesEstimationAdminService,
    private feesEstimationService: FeesEstimationService, private translate: TranslateService, ) {
    this.isShow = true;
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.user = this.globalSrv.user;

  }

  ngOnInit() {
    this.buildForm();

  }

  get f() {
    return this.measurementOfficerForm.controls;
  }

  buildForm() {
    this.measurementOfficerForm = this.formBuilder.group({
      InsuranceValue: new FormControl('', [Validators.pattern(this.numberRegex)]),
      FeeValue: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
      Decision: ['', Validators.required],
      Currency: new FormControl({ value: '', disabled: true }),
      MeasurementDescription: ['']
    });
  }


  getBaseRequest() {
    this.feesEstimationService.get(this.baseRequestId).pipe(first()).subscribe(
      d => {
        if (d.Success) {
          this.feesEstimationObj = d.Data;
          this.requestStatus = this.feesEstimationObj.StatusId;
          this.agentId = this.feesEstimationObj.RequestorId;
          if (this.globalSrv.getLanguage() == Languages.Arabic) {

            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameAR,
            });
          }
          else {
            this.measurementOfficerForm.patchValue({
              Currency: this.feesEstimationObj.Currency.NameEN,
            });
          }

          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
            this.measurementOfficerForm.disable();
            this.measurementOfficerForm.patchValue({
              FeeValue: this.feesEstimationObj.FeeValue,
              InsuranceValue: this.feesEstimationObj.InsuranceValue,
              MeasurementDescription: this.feesEstimationObj.MeasurementDescription
            });
          }

          else if (this.requestStatus == ServiceStatus.PendingOnMeasurementsOfficerApproval) {
            this.formMode = FormMode.Add;
            this.measurementOfficerForm.enable();
            this.measurementOfficerForm.controls.Currency.disable();
          }
          else {
            this.formMode = FormMode.Readonly;
            if (this.requestStatus == ServiceStatus.PendingonMeasurementsDepartmentManagerApproval) {
              this.measurementOfficerForm.enable();
              this.measurementOfficerForm.controls.Currency.disable();
            }
            else {
              this.measurementOfficerForm.disable();
            }
            this.measurementOfficerForm.patchValue({
              FeeValue: this.feesEstimationObj.FeeValue,
              InsuranceValue: this.feesEstimationObj.InsuranceValue,
              MeasurementDescription: this.feesEstimationObj.MeasurementDescription
            });
          }

        }

      }
    )
  }

  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.measurementOfficerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.MeasurmentOffcierObject = this.measurementOfficerForm.value;
    this.MeasurmentOffcierObject.AdminEmail = this.user.UserName;
    this.MeasurmentOffcierObject.RequestId = this.baseRequestId;


    this.feesSrv.fillMeasurmentFees(this.MeasurmentOffcierObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.measurementOfficerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
